export const CLIENT_NAME_OPTIONS = [
  '100 Ballniy Repetitor',
  '12Storeez',
  '1skin',
  '4Lapy',
  '5element',
  '5Post',
  'Гайд Гоу Директ',
  'Галс-Девелопмент',
  'МегаКампус',
  'Мобайл ООО',
  'AAG',
  'ABBA',
  'Abbot',
  'Abi Product',
  'Advantshop',
  'Aeroflot',
  'AFI Development',
  'AGR',
  'Akrihin',
  'Alabuga',
  'Aleshkin Fond',
  'Alfa Strahovanie',
  'Alfa Zdorovie',
  'Alfa-Bank',
  'Alia',
  'Alleya group',
  'Almette',
  'Alrosa',
  'Alrosa Fancy',
  'Amediateka',
  'ANO Tourism',
  'Ant Development',
  'Antares',
  'Apteka ru',
  'Apteki plus',
  'Aquaphor',
  'Arlight',
  'Arnest',
  'Ascensia',
  'Asfarma Medical',
  'Askona',
  'AST.wine',
  'Astra',
  'Atmosphera kino',
  'Atol',
  'Atribeaute Kids',
  'Autospot',
  'Avanta',
  'Aviapark',
  'Aviasales',
  'Avito',
  'Avtoliga',
  'Azbuka Vkusa',
  'B-Apteka',
  'Bajkal servis',
  'Baltica',
  'Bank Sinara',
  'Bank SPB',
  'Banki.ru',
  'Baon',
  'Barilla',
  'Bayer',
  'BCS',
  'BDF',
  'Beeline',
  'Befree',
  'Belaya Ruza',
  'Belebeevskiy',
  'Belkvartal',
  'Belyi Krolik',
  'Bendes',
  'Between',
  'Bezen',
  'Bifiform',
  'Binnofarm',
  'BMW',
  'Boardriders',
  'Boggi',
  'Boobl Goom',
  'Boostra',
  'Bork',
  'Botanica',
  'BRD',
  'bringads',
  'Burgerking',
  'Buzzoola',
  'Calltouch',
  'Calzedonia',
  'Cdek',
  'Cersanit',
  'Cha-U-Kao',
  'Changan',
  'Cherdak',
  'Chery',
  'Cian',
  'Citilink',
  'Citomed',
  'CityDraiv',
  'Citydrive',
  'Coldy',
  'Consortium',
  'Crocusfitness',
  'CSC',
  'Cvetofor',
  'DDX fitness',
  'Delikaiser',
  'Delo Bank',
  'Delovye linii',
  'Dentservice',
  'Detailing',
  'Detravenol',
  'Detskiy Mir',
  'Direct',
  'Distant College',
  'Divage',
  'Divan ru',
  'Dixy',
  'Dobriy tomat',
  'Dobryninskiy',
  'DoDo Pizza',
  'Dogma',
  'Dom RF',
  'Domclick',
  'DomDau',
  'Donstroy',
  'Doppel Herz',
  'Dostaevsky.ru',
  'Dr Reddys',
  'DTMD',
  'DV',
  'Dyadya Vanya Trading',
  'Dyatkovo',
  'Eastclinic',
  'Eberhart',
  'Ecco',
  'Econika',
  'Eduson',
  'EFKO',
  'Egeturbo',
  'Elanco',
  'Eldorado',
  'Elemax',
  'Elis',
  'Elit',
  'Emka',
  'Epoha Сhudes',
  'Er-telecome',
  'Eskimer',
  'Estima',
  'Europribor',
  'Evalar',
  'Evolute',
  'Excimer Clinic',
  'Exeed',
  'Exponenta',
  'Expostroy',
  'Farmasintez',
  'FAW',
  'Fetaxa',
  'Finn Flare',
  'First Taxi',
  'Flash-taxi',
  'Flex',
  'Flowwow',
  'Formost Production',
  'Forsage Haval',
  'Forsage Lada',
  'Francesco Donni',
  'Frau Marta',
  'FSK',
  'Funday',
  'Gac',
  'Galderma',
  'GALS Development',
  'Ganzo',
  'Gazprombank',
  'Gazprombonus',
  'Gazpromneft',
  'Gedeon Richter',
  'Geely',
  'GEOX',
  'GetForClick',
  'Gipopo',
  'giraff',
  'Girlyandy Moscow',
  'Gislaved',
  'GK Osnova',
  'GK Volna',
  'Glavstroy',
  'Glazclinica',
  'Glorax',
  'Gloria Jeans',
  'Gold Apple',
  'Golos Development',
  'Goodgrad',
  'Gorilla Energy',
  'Gradient',
  'Grand',
  'Granel',
  'Gravion',
  'Groupprice',
  'Grunlander',
  'Guide go',
  'Gulliver',
  'Hadassah',
  'Hansa',
  'Happy Land',
  'Haval',
  'Hcresort',
  'Henkel',
  'Hills-sport',
  'Hobbyworld',
  'Hochland',
  'Hoegl',
  'Hoff',
  'Holodilnik',
  'Huawei',
  'Huggies',
  'hybrid',
  'IDOL',
  'Igcity',
  'IledeBeaute',
  'IModern',
  'Incanto',
  'Ingosstrakh',
  'Innolaba ВК',
  'Innolaba Директ',
  'Innolaba Магнетто',
  'Inspiritum',
  'Internet anketa',
  'Invitro',
  'Ipsen',
  'Irisdelica',
  'Jamilco',
  'Jazeera Airways',
  'JDE',
  'Jetour',
  'Kant',
  'Kanzler',
  'Karo Prokat',
  'Kaskad',
  'Kaspersky',
  'Kazanexpress',
  'KDL',
  'Kems',
  'Kinoburo',
  'Kinostudiya Olimp',
  'Klinika 31',
  'Knauf',
  'Kolesa darom',
  'kombinat',
  'Komus',
  'Kontur',
  'Krasniy Karandash',
  'Krasniy oktyabr',
  'KuchenLand',
  'Kuper',
  'Kvartal momenty',
  'La vivion',
  'LAB',
  'Lada',
  'Laredoute',
  'Laser Land',
  'Laska',
  'Laundry',
  'Lennuf',
  'Lenta',
  'Leroy Merlin',
  'Letto',
  'Letual',
  'Level',
  'Lex',
  'Lime Shop',
  'Logos',
  'Lokobank',
  'Love Republic',
  'Lyubimiy dom',
  'Lyubyatovo',
  'M5',
  'Madame Coco',
  'Magnit',
  'Mail.ru',
  'Makfa',
  'Mamba',
  'Mango Office',
  'Mannol',
  'Marc & Andre',
  'Mareven',
  'Marytrufel',
  'Mavis',
  'Maxidom',
  'Maxus',
  'May Brands',
  'Mayoly',
  'Mayoly Pharma',
  'MB Rus',
  'MBM',
  'MDG.TV',
  'MDM',
  'MediaSniper',
  'Medok',
  'Megacampus',
  'Megafon',
  'Megastroy',
  'Metallinvestbank',
  'Metro',
  'MGUU',
  'Midea',
  'Mikrohirurgiya Glaza',
  'Mir kubikov',
  'Miratorg',
  'Mirbis',
  'Mircli',
  'Mistral',
  'Mitsubishi',
  'MIUZ',
  'MMH',
  'Mnogo Lososya',
  'Mobius sklad',
  'MOjNO',
  'Moment Montazh',
  'Moments',
  'Monetka',
  'Moneyman',
  'Moretut',
  'Moskovskie Okna',
  'Moskovskya Birzha',
  'Moskvich',
  'Motorcycles',
  'Motorinvest',
  'Moymir',
  'MPC',
  'Mr Doors',
  'MR Group',
  'MTS',
  'MTS Bank',
  'MTS Fog play',
  'MTS KION',
  'MTS Link',
  'MTS Nuum',
  'MTS Shop',
  'Multon',
  'MVideo',
  'My Office',
  'My-Shop',
  'Myscore',
  'NAOS',
  'Nashe Kino',
  'National Lotery',
  'Nazlotereya',
  'Nemoloko',
  'Netprint',
  'Niidpo',
  'Nivea',
  'NMG',
  'No ONE',
  'Nonton',
  'Novoe Letovo',
  'NSPK',
  'NTV+',
  'Nutricia',
  'OBI',
  'Obrazcovie kvartaly',
  'OKB',
  'Okko',
  'Oliviamed',
  'Omoda',
  'Omsa',
  'Ondulin',
  'One Two Trip',
  'Orimi',
  'Ormatek',
  'Orteka',
  'Ostankino',
  'Ostin',
  'Ostrov Mechty',
  'Ostrovok',
  'OTC',
  'Otello',
  'Otkrytie',
  'OTM',
  'Ozon',
  'Ozon bank',
  'P7',
  'PAO KIB',
  'Parus',
  'Pasionaria',
  'Patina',
  'Pavlovy Ozera',
  'Perekrestok',
  'Petrovich',
  'Pharmamed',
  'Pharmasyntez',
  'Pharmstd',
  'PIK',
  'Pik-Pharma',
  'Pioneer',
  'Pm.ru',
  'PochtaBank',
  'Podrygka',
  'Polisan',
  'Polisorb',
  'Potok',
  'Pride',
  'Prime Park',
  'Privilegiya',
  'Progress',
  'Prosto App',
  'PROzakupka',
  'PSB',
  'PSK',
  'PSLAB',
  'Pult',
  'Pyaterochka',
  'Rakurs',
  'RBI',
  'Re-commerce',
  'Redmond',
  'Redsolution',
  'Reenergo',
  'Rehab',
  'Rehau',
  'Rendez-vous',
  'Renessans Strahovanie',
  'Renna Holding',
  'RESO Leasing',
  'Respect',
  'reStore',
  'RG Development',
  'Rigla',
  'Ritmy Mechty',
  'Rivegauche',
  'Roche',
  'Rocketbank',
  'Rodnie korma',
  'Rodnie Zemly',
  'Rodnoy Ochag',
  'Rollton',
  'Rosbank',
  'Rost',
  'Rostelecom',
  'Rostelecom // PBD',
  'Rostics',
  'Royal Clima',
  'RT',
  'Rusagro',
  'Rutube',
  'Ruviki',
  'RZHD',
  'S7',
  'Salskselmash',
  'Samokat',
  'Samolet',
  'Sampad',
  'Samsung',
  'Sanofi',
  'Santehnika online',
  'Santehnika Tut',
  'Sape',
  'Savin Family',
  'Savoy Wellness',
  'Savushkin',
  'Sber',
  'SberAuto',
  'Sberbank',
  'Sberbiznes',
  'SberCity',
  'Sberdevaisy',
  'Sberinvestizii',
  'Sberinvestor',
  'SberJazz',
  'Sberlizing',
  'Sbermarket',
  'Sbermobile',
  'Sberpraim',
  'SberPremier',
  'SberSpasibo',
  'Sberstrahovanie',
  'Schastie',
  'Sela',
  'Selvim',
  'Senfeng',
  'Seres',
  'Servier',
  'Severboat',
  'Severniy Port',
  'Shinservis',
  'Shoppinglive',
  'Sinotechmash',
  'Sintec',
  'Skazochniy Svet',
  'Skillbox',
  'SkillFactory',
  'SKYeng',
  'Skylink',
  'Smeshariki',
  'Sminex',
  'SMMarket',
  'Snow Queen',
  'Solos',
  'Son.ru',
  'Sopharma',
  'Sorb',
  'Soteks',
  'Sovcombank',
  'Soyuzmultfilm',
  'Spa Residenсia Les',
  'SpiritFitness',
  'SporaGT',
  'Sportmaster',
  'Sravni ru',
  'Sreda obucheniya',
  'Stada // Weborama',
  'Stadion',
  'Start',
  'Staya Dog',
  'Stokman',
  'Stolichki',
  'Stoloto',
  'Stoloto // Weborama',
  'Stolplit',
  'Street Beat',
  'Subbota',
  'Sunhouse',
  'Svyatoj istochnik',
  'Swiss',
  'Syrobogatov',
  'SZ KVS Vyborgskiy',
  'SZ Novaya zhizn - Royka',
  'SZ Novaya zhizn Ulyanovsk',
  'SZ PSF Krost',
  'SZ Sadovoe koltso',
  'T-Bank',
  'Talan',
  'Tamaris',
  'Tank',
  'Teboil',
  'Tele-2',
  'Teperikovahair',
  'Teplolux',
  'Terle Park',
  'Tikkurila',
  'Tinkoff',
  'Tkachev Clinic',
  'Tomoru',
  'Tornado',
  'Tosol-Sintez',
  'Traektoria',
  'Transatlantik',
  'Tsentralniy',
  'TSUM',
  'Tubor',
  'UAZ',
  'Ugleche Pole',
  'umg',
  'Umschool',
  'Unipharm',
  'Utkonos',
  'Valenta',
  'Valoapart',
  'Valohotelcity',
  'vector360',
  'Vegas',
  'Verofarm',
  'Vertex',
  'Viferon',
  'Viju',
  'Villamonte',
  'Vipavenue',
  'Vitaclinica',
  'VIVO',
  'VK',
  'VKontakte',
  'Vkusno i tochka',
  'Vkusvill',
  'Vodohod',
  'Volgafilm',
  'Volhovec',
  'Volshebnye skazki',
  'Vseinstrumenti',
  'VSK',
  'VTB',
  'Webinar.ru',
  'Welcom',
  'Well Apart',
  'White Square Partners',
  'Wildberries',
  'Wink',
  'Wohl Design',
  'X-Clinic',
  'X5 Club',
  'X5 Paket',
  'X5staff',
  'Xcom‑shop',
  'Yandex',
  'Yandex 360',
  'Yandex Alice',
  'Yandex Eda',
  'Yandex Lavka',
  'Yandex Market',
  'Yandex.Go',
  'Yappy',
  'YLG',
  'Yokohama',
  'Yukassa',
  'Yves Rocher',
  'Zdravcity',
  'zentotem',
  'Zerocoder',
  'Zetter',
  'Zhelezno',
  'Zhirovoy Kombinat',
  'ZHK Kit',
  'ZILLII',
  'Znanie',
  'Zoozavr',
  'Zvezdy arbata',
  'Zvuk',
];
